import { sh } from '@tpluscode/rdf-ns-builders';
import ConstraintComponent from './ConstraintComponent.js';
export class HasValueConstraintComponent extends ConstraintComponent {
    constructor(terms) {
        super(sh.HasValueConstraintComponent);
        this.terms = terms;
    }
    static *fromShape(shape) {
        const values = shape.get(sh.hasValue);
        if (values) {
            const terms = values.flatMap(hv => 'list' in hv ? [] : hv.pointer.term);
            yield new HasValueConstraintComponent(terms);
        }
    }
    buildNodeShapePatterns() {
        return [];
    }
    buildPropertyShapePatterns({ focusNode, propertyPath, valueNode }) {
        if (this.terms.length === 1) {
            return [{
                    type: 'values',
                    values: this.terms.map(term => ({
                        ['?' + valueNode.value]: term,
                    })),
                }];
        }
        const triples = this.terms.map(term => ({
            subject: focusNode,
            predicate: propertyPath,
            object: term,
        }));
        return [{
                type: 'filter',
                expression: {
                    type: 'operation',
                    operator: 'exists',
                    args: [{
                            type: 'bgp',
                            triples,
                        }],
                },
            }];
    }
}
